import {
  McpServerConnectionCreateInput,
  McpServerConnectionUpdateInput,
} from '@vivport/backend/types';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  createMcpServerConnection,
  deleteMcpServerConnection,
  listMcpServerConnections,
  pinMcpServerConnection,
  probeMcpServerConnection,
  updateMcpServerConnection,
} from '../api/mcp-server-connection-api';

export const mcpConnectionKeys = {
  all: ['mcp-server-connections'] as const,
  list: () => [...mcpConnectionKeys.all, 'list'] as const,
};

export const useMcpServerConnections = (enabled = true) =>
  useQuery({
    queryKey: mcpConnectionKeys.list(),
    queryFn: () => listMcpServerConnections(),
    enabled,
  });

export const useCreateMcpServerConnection = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: McpServerConnectionCreateInput) => createMcpServerConnection(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: mcpConnectionKeys.list() });
    },
  });
};

export const useUpdateMcpServerConnection = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: number; input: McpServerConnectionUpdateInput }) =>
      updateMcpServerConnection(id, input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: mcpConnectionKeys.list() });
    },
  });
};

export const useDeleteMcpServerConnection = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => deleteMcpServerConnection(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: mcpConnectionKeys.list() });
    },
  });
};

export const usePinMcpServerConnection = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => pinMcpServerConnection(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: mcpConnectionKeys.list() });
    },
  });
};

export const useProbeMcpServerConnection = () =>
  useMutation({
    mutationFn: (id: number) => probeMcpServerConnection(id),
  });
